export default defineNuxtRouteMiddleware((to) => {
    if (to.query.redirect) {
        return navigateTo(to.query.redirect.toString());
    }
    // Remove buggy hash added by Keycloak after guest visits
    else if (
        to.hash
        && (to.hash.startsWith('#error=login_required') || to.hash.startsWith('#state'))
    ) {
        return navigateTo({ path: to.path, query: to.query });
    }
});
